<template>
  <div>
    <a-layout-content>
      <a-breadcrumb>
        <a-breadcrumb-item>系统设置</a-breadcrumb-item>
        <a-breadcrumb-item>用户管理</a-breadcrumb-item>
      </a-breadcrumb>
      <a-layout style="background: #fff">
        <a-layout-content :style="{ minHeight: '280px' }">
          <div class="list-box">
            <div class="list-header">
              <div>
                <a-button @click="handleOpenAddModel" type="primary"> <a-icon type="plus" />添加用户 </a-button>
                <a-button @click="handleSendEmail" :disabled="selectedRowKeys.length < 1" class="gap-10" type="primary">
                  <a-icon type="mail" />邮件邀请
                </a-button>
              </div>
              <div class="header-right">
                <div class="text margin-10">
                  筛选结果：共<strong>{{ totalUser }}</strong
                  >名用户
                </div>
                <!-- <div style="display: flex;align-items:flex-end"> 筛选结果：共{{ totalUser }}名用户</div> -->
                <a-select
                  placeholder="按状态筛选"
                  defaultValue="normalUsers"
                  class="margin-10"
                  style="width: 100px"
                  @change="handleStatusChange"
                  @popupScroll="popupScroll"
                >
                  <a-select-option key="allUsers">全部用户</a-select-option>
                  <a-select-option key="normalUsers">正常用户</a-select-option>
                  <a-select-option key="abnormalUsers">已冻结用户</a-select-option>
                </a-select>
                <!-- 角色select -->
                <a-select
                  placeholder="按角色筛选"
                  defaultValue="all"
                  class="margin-10"
                  style="width: 200px"
                  @change="handleRoleChange"
                  @popupScroll="popupScroll"
                >
                  <a-select-option key="all">全部用户</a-select-option>
                  <a-select-option v-for="v in allRoleList" :key="v.id">{{ v.name }}</a-select-option>
                </a-select>

                <a-input style="width: 230px" v-model="keyword" placeholder="搜索用户 昵称/用户名/微信名" ref="keywordInput">
                  <a-icon slot="prefix" type="search" />
                  <a-icon v-if="keyword" slot="suffix" clear type="close-circle" @click="emitEmpty" />
                </a-input>
              </div>
            </div>
          </div>
          <!-- 状态select -->

          <a-table
            class="table"
            :loading="loading"
            :columns="columns"
            :dataSource="userList"
            :rowKey="record => record.id"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            :pagination="pagination"
            @change="handleTableChange"
          >
            <a-tooltip slot="avatar" slot-scope="row" placement="top">
              <a-avatar :src="row.avatar" class="avatar-bg">{{ row.nickname[0] }}</a-avatar>
            </a-tooltip>
            <span :class="{ 'text-danger': status === -1 }" slot="status" slot-scope="status">
              {{ USER_STATUS(status) }}
            </span>
            <span slot="ifInvestTeam" slot-scope="row">
              {{ row.ifInvestTeam ? '是' : '否' }}
            </span>
            <div slot="nameCode" slot-scope="row">
              <p>邮箱：{{ row.name }}</p>
              <span>邀请码：{{ row.code || '---' }}</span>
            </div>
            <!-- 角色展示 -->
            <div slot="roles" slot-scope="row">
              <span v-for="(role, index) in row.roles" :key="index">
                {{ role.name }}
                <a-divider type="vertical" v-if="index !== row.roles.length - 1" />
              </span>
            </div>
            <div slot="action" slot-scope="row">
              <a-button @click="handleEditClick(row)" type="primary" size="small" class="btn">编辑</a-button>
              <a-button @click="changeUserStatus(row)" :type="row.status == -1 ? 'primary' : 'danger'" size="small" class="btn">
                {{ row.status == -1 ? '启用' : '停用' }}
              </a-button>
              <!-- <a-button @click="handleDeleteUser(row)" size="small" type="danger">删除</a-button> -->
            </div>
          </a-table>
        </a-layout-content>
      </a-layout>
    </a-layout-content>

    <!-- 添加用户 -->
    <a-modal title="添加用户" @cancel="closeModel" :visible="showModel == 'addUser'" :width="580">
      <a-form :form="formAddUser">
        <a-form-item label="邮箱：" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" required>
          <a-input v-model="addUserformData.name" placeholder="用户名(邮箱)" />
        </a-form-item>
        <a-form-item label="昵称：" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" required>
          <a-input v-model="addUserformData.nickname" placeholder="真实姓名，昵称" />
        </a-form-item>
        <a-form-item label="微信：" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-input v-model="addUserformData.weixin" placeholder="微信"></a-input>
        </a-form-item>
        <a-form-item
          label="手机："
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 20 }"
          required
          :validate-status="phoneCheck.status"
          :help="phoneCheck.errmsg"
        >
          <a-input v-model="addUserformData.phone" placeholder="手机号" :maxlength="11" />
        </a-form-item>
        <a-form-item label="角色设置：" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-select
            v-model="addUserformData.roleIds"
            mode="multiple"
            placeholder="角色设置"
            :filterOption="false"
            notFoundContent="暂无数据"
            showSearch
            @dropdownVisibleChange="getRoleList"
            @search="handleRoleInputChange"
            @popupScroll="popupScroll"
          >
            <a-select-option v-for="v in allRoleList" :key="v.id">{{ v.name }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="所属BU" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-select mode="multiple" placeholder="选择BU" v-model="addUserformData.buList" :filterOption="false">
            <a-select-option v-for="item in buList" :key="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="推荐参会：" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" required>
          <a-radio-group v-model="addUserformData.ifInvestTeam" buttonStyle="solid" :default-value="false">
            <!-- //TODO  -->
            <a-radio-button :value="true">是</a-radio-button>
            <a-radio-button :value="false">否</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="用户状态：" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-radio-group v-model="addUserformData.status" buttonStyle="solid">
            <a-radio-button :value="0">正常</a-radio-button>
            <a-radio-button :value="-1">冻结</a-radio-button>
          </a-radio-group>
        </a-form-item>
      </a-form>
      <template slot="footer">
        <a-button @click="closeModel">取消</a-button>
        <a-button type="primary" @click="handleAddOrEditUser('add')">确定</a-button>
      </template>
    </a-modal>

    <!-- 编辑用户信息 -->
    <a-modal title="编辑用户信息" @cancel="closeModel" :visible="showModel == 'editUser'" :width="580">
      <a-form>
        <a-form-item label="邮箱：" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-input v-model="currentRow.name" placeholder="用户名(邮箱)"></a-input>
        </a-form-item>
        <a-form-item label="昵称：" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-input v-model="currentRow.nickname" placeholder="真实姓名，昵称"></a-input>
        </a-form-item>
        <a-form-item label="微信：" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-input v-model="currentRow.weixin" placeholder="微信"></a-input>
        </a-form-item>
        <a-form-item label="手机：" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" :validate-status="phoneCheck.status" :help="phoneCheck.errmsg">
          <a-input v-model="currentRow.phone" placeholder="手机号" :maxlength="11" />
        </a-form-item>
        <a-form-item label="角色设置：" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-select v-model="currentRow.roleNames" mode="multiple" placeholder="角色设置" :filterOption="true" showSearch @dropdownVisibleChange="getRoleList">
            <a-select-option v-for="v in roleList" :key="v.id" :value="v.name">{{ v.name }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="RankScore："
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 20 }"
          required
          :validate-status="rankScoreCheck.status"
          :help="rankScoreCheck.errmsg"
        >
          <a-input v-model="currentRow.sort" placeholder="RankScore" />
        </a-form-item>

        <a-form-item label="所属BU" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-select mode="multiple" placeholder="选择BU" v-model="currentRow.buList" :filterOption="false">
            <a-select-option v-for="item in buList" :key="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="推荐参会：" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" required>
          <a-radio-group v-model="currentRow.ifInvestTeam" buttonStyle="solid" :default-value="false">
            <a-radio-button :value="true">是</a-radio-button>
            <a-radio-button :value="false">否</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="用户状态：" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-radio-group v-model="currentRow.status" buttonStyle="solid">
            <a-radio-button :value="0">正常</a-radio-button>
            <a-radio-button :value="-1">冻结</a-radio-button>
          </a-radio-group>
        </a-form-item>
      </a-form>
      <template slot="footer">
        <a-button @click="closeModel">取消</a-button>
        <a-button type="primary" @click="handleAddOrEditUser('edit')">确定</a-button>
      </template>
    </a-modal>
    <!-- <a-modal title="用户授权" @cancel="closeModel"
      :visible="showModel=='setPower'">
      <a-radio-group defaultValue="1" buttonStyle="solid">
        <a-radio-button value="1">项目</a-radio-button>
        <a-radio-button value="2">会议</a-radio-button>
        <a-radio-button value="3">文件</a-radio-button>
      </a-radio-group>
      <template slot="footer">
        <a-button @click="closeModel">取消</a-button>
        <a-button type="primary">确定</a-button>
      </template>
    </a-modal>-->
  </div>
</template>
<script>
import { userList, addUser, editUser, operateUser, sendCodeEmail } from '@/api/systemUserSetting.js';
import { roleList } from '@/api/systemRoleSetting.js';
import { USER_STATUS } from '@/const/common';
import debounce from 'lodash/debounce';
import { getBuList } from '@/api/common.js';
const columns = [
  { title: '头像', align: 'center', scopedSlots: { customRender: 'avatar' } },
  { title: '姓名', dataIndex: 'nickname', align: 'center' },
  { title: '手机', dataIndex: 'phone' },
  { title: '邮箱/邀请码', scopedSlots: { customRender: 'nameCode' } },
  { title: '角色', align: 'center', scopedSlots: { customRender: 'roles' } },
  {
    title: '所属BU',
    dataIndex: 'buList',
    width: 100,
    customRender(bu) {
      return bu.map(i => i.name).join(', ');
    }
  },

  {
    title: '推荐参会',
    width: '64px',
    align: 'center',
    scopedSlots: { customRender: 'ifInvestTeam' }
  },
  {
    title: '状态',
    width: '64px',
    dataIndex: 'status',
    align: 'center',
    scopedSlots: { customRender: 'status' }
  },
  { title: '操作', width: '136px', align: 'center', scopedSlots: { customRender: 'action' } }
];
const userTypeList = [{ type: 'all', name: '所有用户', icon: 'users' }];
export default {
  data() {
    this.handleRoleInputChange = debounce(this.handleRoleInputChange, 800);
    return {
      selectedRowKeys: [],
      userTypeList,
      phoneCheck: {
        status: '',
        errmsg: ''
      },
      rankScoreCheck: {
        status: '',
        errmsg: ''
      },
      buList: [],
      formAddUser: this.$form.createForm(this),
      loading: true,
      pagination: { total: 0, current: 1, defaultPageSize: 100 },
      showModel: '',
      addUserModal: false,
      keyword: '',
      currentType: ['all'],
      currentTitle: '所有用户',
      userList: [],
      BuList: [],
      columns,
      roleList: [],
      rolePagination: {
        current: 1,
        total: 0
      },
      roleKeyWord: '',
      addUserformData: {
        name: '',
        code: '',
        nickname: '',
        phone: '',
        addUserformData: 0,
        buList: [],
        weixin: '',
        avatar: '',
        roleIds: [],
        status: 0
      },
      currentRow: {},
      selectStatus: '0', //用户状态
      selectRole: '', //用户角色
      totalUser: 0, //筛选后用户总数
      allRoleList: [], //所有角色
      totalRole: 0
    };
  },
  computed: {
    tableData() {
      return userList.map(i => {
        return {
          ...i
        };
      });
    }
  },
  watch: {
    keyword() {
      this.getUserList();
    }
  },
  methods: {
    //请求用户列表
    getUserList(page) {
      this.loading = true;
      userList({
        page: page || 1,
        pageSize: 100,
        searchName: this.keyword,
        userStatus: this.selectStatus,
        roleId: this.selectRole
      }).then(res => {
        this.loading = false;
        //获取筛选后用户总数
        this.totalUser = res.data.total;
        this.pagination.total = res.data.total;
        this.pagination.current = res.data.page;
        this.userList = res.data.list;
        this.loading = false;
      });
    },
    //按状态筛选
    handleStatusChange(value) {
      if (value === 'normalUsers') {
        this.selectStatus = '0';
      } else if (value === 'abnormalUsers') {
        this.selectStatus = '-1';
      } else {
        this.selectStatus = '';
      }
      //发请求获取用户列表
      this.getUserList();
    },
    //按角色筛选
    handleRoleChange(value) {
      this.selectRole = value.toString();
      if (this.selectRole === 'all') {
        this.selectRole = '';
      }
      //发请求获取用户列表
      this.getUserList();
    },
    handleEditClick(row) {
      //点击编辑按钮，roleList和该用户有的roles合并，解决出现id(数字)的bug
      console.log('row', row);
      if (!row.roleIds) {
        row.roleIds = [];
      }
      let buList = [];
      if (row.buList) {
        buList = row.buList.map(i => i.id);
      }

      this.currentRow = {
        ...row,
        roleNames: row.roles.map(_ => _.name),
        buList: buList
      };
      this.showModel = 'editUser';
      if (!row.roles) return;
      row.roles.forEach(item => {
        let temp = this.roleList.filter(list => list.id === item.id);
        if (temp.length < 1) {
          this.roleList.unshift(item);
        }
      });
    },
    handleSendEmail() {
      this.loading = true;
      sendCodeEmail(this.selectedRowKeys).then(res => {
        this.loading = false;
        if (res.code === 200) {
          this.$message.success(res.data || 'success');
          this.selectedRowKeys = [];
        }
      });
    },
    handleOpenAddModel() {
      this.showModel = 'addUser';
      this.$set(this, 'addUserformData', {
        name: '',
        code: '',
        nickname: '',
        phone: '',
        addUserformData: 0,
        buList: [],
        weixin: '',
        avatar: '',
        roleIds: [],
        status: 0
      });
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    popupScroll(e) {
      // 用户列表的滚动下拉加载
      const { scrollHeight, scrollTop, clientHeight } = e.target;
      const END = scrollHeight - scrollTop <= clientHeight;
      const GETALL = this.roleList.length >= this.rolePagination.total;
      if (END) {
        if (!GETALL) {
          this.rolePagination.current++;
          roleList({
            ...this.rolePagination,
            searchWord: this.roleKeyWord
          }).then(res => {
            this.rolePagination.current = res.data.page;
            this.rolePagination.total = res.data.total;
            this.roleList = this.roleList.concat(res.data.list);
          });
        }
      }
    },
    handleRoleInputChange(e) {
      console.log('handleRoleInputChange');
      if (e) {
        this.roleKeyWord = e;
        this.rolePagination.current = 1;
        roleList({ ...this.rolePagination, searchWord: e }).then(res => {
          this.roleList = res.data.list;
          this.rolePagination.current = res.data.page;
          this.rolePagination.total = res.data.total;
        });
      } else {
        this.roleList = this.allRoleList.slice(0);
      }
    },
    handleTableChange(pagination) {
      this.getUserList(pagination.current);
    },
    closeModel() {
      this.showModel = '';
      this.phoneCheck.status = '';
      this.phoneCheck.errmsg = '';
      this.rankScoreCheck.status = '';
      this.rankScoreCheck.errmsg = '';
    },
    changeUserStatus(row) {
      if (row.status === 0) {
        this.$confirm({
          title: `确定停用改用户：${row.name}吗？`,
          okText: '停用',
          okType: 'danger',
          cancelText: '再想想',
          onOk: () => {
            operateUser({
              accountId: row.id,
              status: -1
            }).then(res => {
              if (res.code === 200) {
                this.$message.success(res.data);
                this.getUserList();
              }
            });
          }
        });
      } else {
        operateUser({
          accountId: row.id,
          status: 0
        }).then(res => {
          if (res.code === 200) {
            this.$message.info('已启用该用户:' + row.name);
            this.getUserList();
          }
        });
      }
    },
    handleAddOrEditUser(action) {
      // 添加编辑用户
      if (action === 'add') {
        if (this.addUserformData.phone.length < 11) {
          this.phoneCheck.status = 'error';
          this.phoneCheck.errmsg = '请输入11为有效的手机号';
          return;
        }
        this.phoneCheck.status = '';
        this.phoneCheck.errmsg = '';
        addUser({
          ...this.addUserformData,
          buIds: this.addUserformData.buList.join(',')
        }).then(res => {
          if (res.code === 200) {
            this.$message.success(res.data);
            this.closeModel();
            this.getUserList();
          }
        });
      } else if (action === 'edit') {
        if (this.currentRow.phone.length < 11) {
          this.phoneCheck.status = 'error';
          this.phoneCheck.errmsg = '请输入11为有效的手机号';
          return;
        }
        if (!/^[-+]?[0-9]*\.?[0-9]+$/.test(this.currentRow.sort)) {
          this.rankScoreCheck.status = 'error';
          this.rankScoreCheck.errmsg = '请输入合法数字';
          return;
        }
        let { name, nickname, phone, weixin, avatar, status, roleIds, sort, ifInvestTeam, buList, roleNames } = this.currentRow;
        console.log(' this.currentRow', this.currentRow);
        let roleIdsTmp = this.allRoleList.filter(_ => roleNames.findIndex(item => item === _.name) > -1).map(_ => _.id);
        console.log('roleIdsTmp', roleIdsTmp);
        let editObj = {
          name,
          nickname,
          phone,
          weixin,
          avatar,
          status,
          roleIds: roleIdsTmp.join(','),
          sort,
          ifInvestTeam,
          buIds: buList.join(',')
        };
        editUser(editObj).then(res => {
          if (res.code === 200) {
            this.$message.success(res.data);
            this.closeModel();
            this.getUserList(this.pagination.current);
          }
        });
        this.phoneCheck.status = '';
        this.phoneCheck.errmsg = '';
        this.rankScoreCheck.status = '';
        this.rankScoreCheck.errmsg = '';
      }
    },
    getRoleList() {
      this.roleList = this.allRoleList.slice(0);
      // roleList().then(res => {
      //   this.roleList = res.data.list;
      //   this.rolePagination.current = res.data.page;
      //   this.rolePagination.total = res.data.total;
      // });
    },
    emitEmpty() {
      this.$refs.keywordInput.focus();
      this.keyword = '';
    },
    getBuList() {
      getBuList().then(i => {
        this.buList = i.data;
      });
    },

    async getAllRoleList(page) {
      try {
        const result = await roleList({ page: page, pageSize: 20, searchWord: '' });
        this.allRoleList = this.allRoleList.concat(result.data.list);
        this.totalRole = result.data.total;
        if (this.totalRole > this.allRoleList.length) {
          this.getAllRoleList(++page);
        } else {
          this.roleList = this.totalRole.slice(0);
        }
      } catch (err) {
        console.log(err);
      }
    },

    // handleDeleteUser(row) {
    //   this.$confirm({
    //     title: `确定删除用户：${row.name}吗？`,
    //     okText: '确定',
    //     okType: 'danger',
    //     cancelText: '取消',
    //     onOk: () => {
    //       operateUser({
    //         accountId: row.id,
    //         status: -2
    //       }).then(res => {
    //         if (res.code === 200) {
    //           this.$message.success(res.data)
    //           this.getUserList()
    //         }
    //       })
    //     }
    //   })
    // },
    USER_STATUS
  },
  async mounted() {
    //获取用户列表
    this.getUserList();
    this.getBuList();
    // 获取所有角色列表
    this.getAllRoleList(1);
  }
};
</script>
<style lang="less" scoped>
.table-header {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
[a-layout-sider] {
  background: #fff;
  padding-right: 10px;
  height: 450px;
  border-right: 1px solid #e8e8e8;
  .ant-menu-inline {
    border-right: none;
  }
}
[clear] {
  // 清除按钮
  font-size: 12px;
  color: #ddd;
}

.list-box {
  .list-header {
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    a {
      text-decoration: none;
    }
    > :first-child {
      font-size: 16px;
    }
    .header-right {
      display: flex;
      .text {
        line-height: 32px;
        color: rgba(0, 0, 0, 0.5);
      }
      .margin-10 {
        margin-right: 8px;
      }
    }
  }
}

.table {
  .btn {
    margin: 4px 4px;
  }
  /deep/ .ant-table-thead > tr > th,
  /deep/ .ant-table-tbody > tr > td {
    overflow-wrap: break-word;
  }
}

@media screen and (max-width: 1440px) {
  .table {
    /deep/ .ant-table-thead > tr > th,
    /deep/ .ant-table-tbody > tr > td {
      padding: 16px 12px;
    }
  }
}

@media screen and (min-width: 1441px) {
  .table {
    /deep/ .ant-table-thead > tr > th,
    /deep/ .ant-table-tbody > tr > td {
      padding: 16px 16px;
    }
  }
}
</style>
